import { IsoTimestampSchema } from "./string-validation"
import { z } from 'zod'

/**
 * Consult Status Schema
 * Reflects Beluga visit states
 */
export const ConsultStatusSchema = z
  .enum(['pending_scheduling', 'scheduled', 'completed', 'missed', 'cancelled'])
  .meta({ id: 'ConsultStatus' })

export type ConsultStatus = z.infer<typeof ConsultStatusSchema>

/**
 * Consult Schema
 */
export const ConsultSchema = z
  .object({
    id: z.string(),
    orderId: z.string(),
    patientId: z.string(),
    patientName: z.string().optional(),
    masterId: z.string().optional(), // Beluga Health reference
    status: ConsultStatusSchema,
    scheduledAt: IsoTimestampSchema.optional(),
    completedAt: IsoTimestampSchema.optional(),
    bookingLink: z.url().optional(),
    clinicianId: z.string().optional(),
    clinicianName: z.string().optional(),
    outcome: z.string().optional(),
    notes: z.string().optional(),
  })
  .meta({ id: 'Consult' })

export type Consult = z.infer<typeof ConsultSchema>

/**
 * Consult Filters Schema
 */
export const ConsultFiltersSchema = z
  .object({
    status: ConsultStatusSchema.optional(),
    page: z.number().int().positive().default(1),
    limit: z.number().int().positive().max(100).default(50),
  })
  .meta({ id: 'ConsultFilters' })

export type ConsultFilters = z.infer<typeof ConsultFiltersSchema>
